export type RuleOperator = 
  | 'equals' 
  | 'not_equals' 
  | 'greater_than' 
  | 'less_than'
  | 'greater_than_or_equal'
  | 'less_than_or_equal'
  | 'contains' 
  | 'not_contains'

export type RuleField = 'inventory_qty' | 'product_type' | 'tags' | 'title' | 'price'

export type LogicalOperator = 'AND' | 'OR'

export interface Rule {
  field: RuleField;
  operator: RuleOperator;
  value: string | number;
}

export interface RuleGroup {
  id: string;
  name: string;
  rules: Rule[];
  logicalOperator: LogicalOperator;
  outcome: 'active' | 'inactive';
  isActive: boolean;
  order: number;
}

export const FIELD_LABELS: Record<RuleField, string> = {
  inventory_qty: 'Inventory Quantity',
  product_type: 'Product Type',
  tags: 'Tags',
  title: 'Product Title',
  price: 'Price'
}

export const OPERATOR_LABELS: Record<RuleOperator, string> = {
  equals: 'Equals',
  not_equals: 'Does not equal',
  greater_than: 'Greater than',
  less_than: 'Less than',
  greater_than_or_equal: 'Greater than or equal to',
  less_than_or_equal: 'Less than or equal to',
  contains: 'Contains',
  not_contains: 'Does not contain'
}

export const FIELD_OPERATORS: Record<RuleField, RuleOperator[]> = {
  inventory_qty: ['equals', 'not_equals', 'greater_than', 'less_than', 'greater_than_or_equal', 'less_than_or_equal'],
  product_type: ['equals', 'not_equals'],
  tags: ['contains', 'not_contains'],
  title: ['equals', 'not_equals', 'contains', 'not_contains'],
  price: ['equals', 'not_equals', 'greater_than', 'less_than', 'greater_than_or_equal', 'less_than_or_equal']
}

export const LOGICAL_OPERATOR_LABELS: Record<LogicalOperator, string> = {
  AND: 'Match ALL conditions (AND)',
  OR: 'Match ANY condition (OR)'
}